import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionsOptionOther extends ConditionRegistryCategory {
    label = 'Antwortoption (andere)';
    constructor(parent) {
        super(parent);
        super.init();
    }
    option_showReveal = () => new ConditionRegistryItem({
        parent: this,
        label: 'Should show Option reveal content',
        eval: ({ question, option }) => !!option &&
            !!question &&
            question.answeringState.isInFeedbackState &&
            option.ownAspect.reveal.aspectContent.regional.hasContent
    });
    isOption1 = () => new ConditionRegistryItem({
        parent: this,
        label: 'is Option1',
        eval: ({ option }) => !!option && option.shuffledOptionNumber === 1
    });
}
